import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/IdentityProvider/GetAll`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export interface ResponseData {
	identityProviders: IdentityProvider[];
}

export type IdentityProvider = {
	id: string;
	name: string;
	iconSvgUrl: string | null;
};
